export const StatsSystemEnum = {
  TotalOrder: 1,
  TotalOrderConsignment: 2,
  TotalUser: 3,
};
